import { keyframes } from '@emotion/react';
import theme from '@styles/theme';
import { TDevToolbarPosition } from '@components/DevToolbar/typescript';
const OpenAnimationTop = keyframes({
  from: {
    visibility: 'hidden',
    top: '-100x'
  },
  to: {
    visibility: 'visible',
    top: '15px'
  }
});
const CloseAnimationTop = keyframes({
  '0%': {
    visibility: 'visible',
    top: '15px'
  },
  '99%': {
    visibility: 'visible',
    top: '-100x'
  },
  '100%': {
    visibility: 'hidden',
    top: '-100x'
  }
});
const OpenAnimationBottom = keyframes({
  from: {
    visibility: 'hidden',
    bottom: '-100px'
  },
  to: {
    visibility: 'visible',
    bottom: '15px'
  }
});
const CloseAnimationBottom = keyframes({
  '0%': {
    visibility: 'visible',
    bottom: '15px'
  },
  '99%': {
    visibility: 'visible',
    bottom: '-100px'
  },
  '100%': {
    visibility: 'hidden',
    bottom: '-100px'
  }
});
export default {
  hoverElement: (position: TDevToolbarPosition, size: number, isDebug: boolean) => ({
    position: 'fixed',
    top: position === 'top' ? `-${Math.ceil(size / 2)}px` : 'auto',
    bottom: position === 'bottom' ? `-${Math.ceil(size / 2)}px` : 'auto',
    left: `calc(50% - ${Math.ceil(size / 2)}px)`,
    width: `${size}px`,
    height: `${size}px`,
    background: isDebug ? 'rgba(255, 0, 0, 0.5)' : 'transparent',
    // pointerEvents: 'none', // dodaj tę linię
    zIndex: theme.zIndex.alerts,
    borderRadius: '50%'
  }),
  toolbarWrapper: (isVisible: boolean, position: TDevToolbarPosition, isDebug: boolean) => {
    const OpenAnimation = position === 'top' ? OpenAnimationTop : OpenAnimationBottom;
    const CloseAnimation = position === 'top' ? CloseAnimationTop : CloseAnimationBottom;
    const positionCss = position === 'top' ? {
      top: '-100px'
    } : {
      bottom: '-100px'
    };
    return {
      animation: isVisible ? `${OpenAnimation} .45s both` : `${CloseAnimation} .45s both`,
      animationTimingFunction: 'cubic-bezier(.54, 0, .58, 1)',
      visibility: 'hidden',
      position: 'fixed',
      width: '100%',
      zIndex: theme.zIndex.alerts,
      background: isDebug ? 'rgba(0, 255, 0, 0.5)' : 'transparent',
      ...positionCss
    };
  },
  toolbar: (position: TDevToolbarPosition, isDebug: boolean) => ({
    width: '100%',
    display: 'flex',
    flexDirection: position === 'top' ? 'column' : 'column-reverse',
    justifyContent: 'center',
    alignItems: 'center',
    top: position === 'top' ? '15px' : 'auto',
    bottom: position === 'bottom' ? '15px' : 'auto',
    background: isDebug ? 'rgba(255, 0, 0, 0.5)' : 'transparent'
  }),
  componentsWrapper: {
    width: 'auto',
    display: 'flex',
    flexFlow: 'row nowrap',
    borderRadius: '20px',
    border: '2px solid #2d313b',
    background: '#0d0d14',
    overflow: 'hidden'
  },
  hoverMe: (isDebug: boolean, size: number, position: 'top' | 'bottom') => ({
    display: isDebug ? 'block' : 'none',
    position: 'absolute',
    bottom: position === 'top' ? `${size / 4}px` : `${size / 1.5}px`,
    left: 'calc(50% - 40px)'
    // zIndex: 99999,
  })
};